export function readBlobAsArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => reject()
    reader.onload = () => {
      reader.result instanceof ArrayBuffer ? resolve(reader.result) : reject()
    }
    reader.readAsArrayBuffer(blob)
  })
}
